import { InputTextarea } from "primereact/inputtextarea";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { wglcsApiService } from "../../services/WglcsApiService";
import SnackBar from "../../views/alert/Toast";
import { Ripple } from "primereact/ripple";
import { t } from "i18next";

interface ReportABugProps {
    OnClose: () => void;
}

interface ReportABugState {
    reportBugComments: string,
    reportBugCommentsErrorText: string,
    attachmentError: string,
    attachment?: File | null,
    attachmentResponse: any,
    isLoading: boolean,
    openSnackBar: boolean,
    toastSeverity: string
}
var text;
class ReportABug extends Component<ReportABugProps, ReportABugState> {

    maxSupportedSize: Number = 4 * 1024 * 1024;

    supportedExtensions: string[] = [
        ".xls",
        ".xlsx",
        ".xlsm",
        ".csv",
        ".pdf",
        ".png",
        ".jpg",
        ".jpeg",
        ".doc",
        ".docx",
        ".txt",
        ".ppt",
        ".pptx",
        ".css",
        ".psd",
        ".gif",
    ];

    constructor(props: ReportABugProps) {
        super(props);

        this.state = {
            openSnackBar: false,
            isLoading: false,
            attachmentError: '',
            attachmentResponse: '',
            reportBugComments: '',
            reportBugCommentsErrorText: '',
            toastSeverity: '',
            attachment: null
        }
    }

    onImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        var file = e.target.files![0];
        var fileExtension = file.name.substring(file.name.lastIndexOf('.'));
        var isExtensionSupported = this.supportedExtensions.includes(fileExtension);

        if (!isExtensionSupported) {
            text=t('errorMessage.isExtensionSupported')
            this.setState({ attachment: null, attachmentError: text })
            return;
        }

        if (file.size as any > this.maxSupportedSize as any) {
            text=t('errorMessage.maxSupportedSize')
            this.setState({ attachment: null, attachmentError:text })
            return;
        }

        this.setState({ attachment: file, attachmentError: '' })
    };

    handleReset = () => {
        this.setState({
            reportBugComments: '',
            attachment: null!
        })
    }

    onSubmitReportBug = async () => {

        if (this.handleValidation()) {
            return;
        }

        if (this.state.reportBugComments.trim().length === 0) {
            text=t("errorMessage.reportBugComments")
            this.setState({ reportBugCommentsErrorText:text })
            return;
        }

        if (this.state.attachment == null) {
            text=t("errorMessage.attachment")
            this.setState({ attachmentError:text })
            return;
        }

        if (this.state.attachmentError !== '') {
            return;
        }

        this.setState({ isLoading: true })

        var formData: FormData = new FormData();
        formData.append('attachment', this.state.attachment, this.state.attachment.name as any);
        formData.append('body', this.state.reportBugComments.trim());

        try {
            let response = await wglcsApiService.reportbug(formData);
            this.setState({ attachmentResponse: response.data })
            this.setState({
                toastSeverity: "success",
                attachmentResponse: response?.data?.msg,
                openSnackBar: true,
                isLoading: false
            });

            setTimeout(() => {
                this.setState({ openSnackBar: false });
                this.props.OnClose()
            }, 3000);

            this.handleReset()
        }
        catch (error) {
            this.setState({ isLoading: false })

            this.setState({
                toastSeverity: "error",
                attachmentResponse: error,
                openSnackBar: true,
            });
            setTimeout(() => {
                this.setState({ openSnackBar: false });
            }, 3000);
        }
    }

    handleValidation = () => {
        var error = false;
        if (this.state.reportBugComments.length < 1 || this.state.reportBugComments === ' ') {
            error = true
            text=t("errorMessage.reportBugComments")
            this.setState({ reportBugCommentsErrorText: text })
        }

        if (this.state.attachment == null) {
            text=t("errorMessage.attachment")
            this.setState({ attachmentError:text })
            error = true
        }
        if (this.state.attachmentError !== '') {
            this.setState({ attachmentError: this.state.attachmentError })
            error = true
        }
        return error
    }

    render(): React.ReactNode {
        return <Modal className="reportABug" toggle={() => this.props.OnClose()} isOpen={true}>
            <ModalHeader>{t('reportBug.header')}
                <button
                    type="button"
                    onClick={this.props.OnClose}
                    data-dismiss="modal"
                    aria-label="Close"
                    className="close p-ripple"
                >
                    <Ripple />  <span aria-hidden="true">&times;</span>
                </button>
            </ModalHeader>
            <ModalBody>
                <label>{t('reportBug.message')}</label>
                <InputTextarea onFocus={e => this.setState({ reportBugCommentsErrorText: "" })} rows={5} style={{ width: "100%" }} value={this.state.reportBugComments} onChange={(e) => this.setState({ reportBugComments: e.target.value })} autoResize />
                <span style={{ color: "red" }}>{this.state.reportBugCommentsErrorText}</span>
                <br />
                <form>
                    <input className="fileInput"
                        type="file"
                        name='image'
                        onChange={(e) => { this.onImageChange(e); }} />

                </form>
                <span style={{ color: "red" }}>{this.state.attachmentError}</span>

            </ModalBody>
            <ModalFooter>
                {this.state.isLoading == true && (
                    <div style={{ marginRight: '20px' }}>
                        <ProgressSpinner
                            style={{ height: "20px", width: "30px", backgroungColor: "red" }}
                            strokeWidth="3"
                            fill="#EEEEEE"
                            animationDuration=".5s"
                        />
                    </div>
                )}
                
                <button className="wgclear-btn p-ripple" onClick={() => this.props.OnClose()}>
                <Ripple />{t('wg-buttons.Cancel')} 
                </button>
                <button style={{ width: '130px', flexDirection: 'row',textTransform:'unset', justifyContent: 'space-around' }} className="wgbtn p-ripple" onClick={() => this.onSubmitReportBug()} >
                <Ripple />  <div> {t('reportBug.header')}</div>
                </button>
            </ModalFooter>
            <SnackBar
                open={this.state.openSnackBar}
                severity={this.state.toastSeverity}
                handleClose={() => { }}
                message={this.state.attachmentResponse}
            />
        </Modal>
    }
}

export default ReportABug;